<script>
	import { getContext, onDestroy } from 'svelte'
	import * as imageConversion from 'image-conversion'
	import { styles } from './scripts/styles'
	import { getCookie } from './scripts/cookie'
	import { admin } from './scripts/PhpHandler.svelte'
	import { update_config_file, get_file_size } from './scripts/utils.js'
	import {
		storeRemainingStorage,
		storeUploader,
		storeActiveBlock,
		storeSingleImageBlock,
		storeUpdate,
		storeIsLinked,
		storeUpdateSingle,
	} from './scripts/Store.svelte'
	import Shader from './ShadersAndSpinners/Shader.svelte'
	import Timer from './LayoutStuff/Timer.svelte'
	import Spinner from './ShadersAndSpinners/SpinnerCircle.svelte'
	export let blockTitle = null
	export let blockIntro = null
	export let singleImageBlock = false
	export let hasLogo = false
	export let isLinked = false
	export let files = null
	const globals = getContext('globals')
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const colorMain = globals.colorMain

	//if user deletes image of a single block we have to delete this image
	//only if the blockTitle !== "logo"
	if (blockTitle !== 'logo') {
		if (!files[0].image) singleImageBlock = false
	}

	let filesCounter = 0

	let activeBlock = null
	const stoActBlock = storeActiveBlock.subscribe((value) => {
		activeBlock = value
	})

	upload_files(files)

	async function upload_files(files) {
		let images = []

		//filter the images path from files array
		let excluded = ['logo']

		if (!excluded.includes(blockTitle)) {
			images = files.map((file) => {
				for (const key in file) {
					if (typeof file[key] === 'object') return file[key]
				}
			})
		}

		if (excluded.includes(blockTitle)) {
			images = [files[0]]
		}

		images.forEach((item) => {
			if (!item) filesCounter++
		})

		//the large image
		const LARGEHEIGHT = 900
		const LARGEWIDTH = 1250

		//medium image
		const MEDIUMHEIGHT = 348
		const MEDIUMWIDTH = 522

		//small image
		const SMALLHEIGHT = 212
		const SMALLWIDTH = 318

		//the thumbnail
		const THUMBHEIGHT = 60
		const THUMBWIDTH = 90

		images.forEach((item, index) => {
			if (item) {
				//seperate name and prefex
				const pfx = item['path'].split('.')

				let reader = new FileReader()
				reader.readAsDataURL(item)
				reader.onload = () => {
					let image = new Image()
					image.src = reader.result
					image.onload = async () => {
						//scale the image to its maxwidth
						let scaleLargeWidth = LARGEWIDTH / image.width
						let scaleLargeHeight = LARGEHEIGHT / image.height
						let scaleMediumWidth = MEDIUMWIDTH / image.width
						let scaleMediumHeight = MEDIUMHEIGHT / image.height
						let scaleSmallWidth = SMALLWIDTH / image.width
						let scaleSmallHeight = SMALLHEIGHT / image.height
						let scaleThumbWidth = THUMBWIDTH / image.width
						let scaleThumbHeight = THUMBHEIGHT / image.height

						let canvasLarge = document.createElement('canvas')
						let ctxLarge = canvasLarge.getContext('2d')
						let canvasMedium = document.createElement('canvas')
						let ctxMedium = canvasMedium.getContext('2d')
						let canvasSmall = document.createElement('canvas')
						let ctxSmall = canvasSmall.getContext('2d')
						let canvasThumb = document.createElement('canvas')
						let ctxThumb = canvasThumb.getContext('2d')

						if (image.width > image.height) {
							canvasLarge.width = LARGEWIDTH
							canvasLarge.height = image.height * scaleLargeWidth
							canvasMedium.width = MEDIUMWIDTH
							canvasMedium.height = image.height * scaleMediumWidth
							canvasSmall.width = SMALLWIDTH
							canvasSmall.height = image.height * scaleSmallWidth
							canvasThumb.width = THUMBWIDTH
							canvasThumb.height = image.height * scaleThumbWidth
						}

						if (image.width < image.height || image.width === image.height) {
							canvasLarge.height = LARGEHEIGHT
							canvasLarge.width = image.width * scaleLargeHeight
							canvasMedium.height = MEDIUMHEIGHT
							canvasMedium.width = image.width * scaleMediumHeight
							canvasSmall.height = SMALLHEIGHT
							canvasSmall.width = image.width * scaleSmallHeight
							canvasThumb.height = THUMBHEIGHT
							canvasThumb.width = image.width * scaleThumbHeight
						}

						ctxLarge.drawImage(image, 0, 0, canvasLarge.width, canvasLarge.height)
						ctxMedium.drawImage(image, 0, 0, canvasMedium.width, canvasMedium.height)
						ctxSmall.drawImage(image, 0, 0, canvasSmall.width, canvasSmall.height)
						ctxThumb.drawImage(image, 0, 0, canvasThumb.width, canvasThumb.height)

						//not for png images, they are not transparent in compression

						if (pfx[1] === 'png') {
							const decodeLarge = ctxLarge.canvas.toDataURL('image/' + pfx[1], 1)
							const decodeMedium = ctxMedium.canvas.toDataURL('image/' + pfx[1], 1)
							const decodeSmall = ctxSmall.canvas.toDataURL('image/' + pfx[1], 1)
							const decodeThumb = ctxThumb.canvas.toDataURL('image/' + pfx[1], 1)

							let name = 'id' + (index + 1) + '_' + pfx[0] + '.' + pfx[1]

							const imgUpload = {
								name: name,
								large: decodeLarge,
								medium: decodeMedium,
								small: decodeSmall,
								thumb: decodeThumb,
							}

							const formData = {
								cmd: 'uploadImage',
								blockname: activeBlock,
								images: imgUpload,
							}

							const response = admin(formData)

							response.then((v) => {
								filesCounter++

								if (filesCounter === images.length) {
									const configFile = update_config_file(
										activeBlock,
										singleImageBlock,
										hasLogo,
										isLinked,
										blockTitle,
										blockIntro,
										files
									)

									configFile.then((cv) => {
										const totalStorage = get_file_size()
										totalStorage.then((sv) => {
											storeRemainingStorage.set(sv)
											storeUploader.set(false)
										})
									})
								}
							})
						}

						if (pfx[1] !== 'png') {
							const largeFile = imageConversion.canvastoFile(canvasLarge, {
								quality: 1,
								type: 'image/' + pfx[1],
							})

							largeFile.then((largeValue) => {
								const compressLarge = imageConversion.compressAccurately(largeValue, {
									quality: 0.8,
									type: 'image/' + pfx[1],
									width: canvasLarge.width,
									height: canvasLarge.height,
									orientation: 0,
									scale: 1,
								})

								compressLarge.then((largeValue) => {
									const largeUrl = imageConversion.filetoDataURL(largeValue)

									largeUrl.then((decodeLarge) => {
										//start the medium image
										const mediumFile = imageConversion.canvastoFile(canvasMedium, {
											quality: 1,
											type: 'image/' + pfx[1],
										})
										mediumFile.then((mediumValue) => {
											const compressMedium = imageConversion.compressAccurately(mediumValue, {
												quality: 1,
												type: 'image/' + pfx[1],
												width: canvasMedium.width,
												height: canvasMedium.height,
												orientation: 0,
												scale: 1,
											})

											compressMedium.then((compMedium) => {
												const mediumUrl = imageConversion.filetoDataURL(compMedium)

												mediumUrl.then((decodeMedium) => {
													//start the small image
													const smallFile = imageConversion.canvastoFile(canvasSmall, {
														quality: 1,
														type: 'image/' + pfx[1],
													})

													smallFile.then((smallValue) => {
														const compressSmall = imageConversion.compressAccurately(smallValue, {
															quality: 1,
															type: 'image/' + pfx[1],
															width: canvasSmall.width,
															height: canvasSmall.height,
															orientation: 0,
															scale: 1,
														})

														compressSmall.then((compSmall) => {
															const smallUrl = imageConversion.filetoDataURL(compSmall)

															smallUrl.then((decodeSmall) => {
																//start thumbnail
																const thumbFile = imageConversion.canvastoFile(canvasThumb, {
																	quality: 1,
																	type: 'image/' + pfx[1],
																})

																thumbFile.then((thumbValue) => {
																	const compressThumb = imageConversion.compressAccurately(thumbValue, {
																		quality: 1,
																		type: 'image/' + pfx[1],
																		width: canvasThumb.width,
																		height: canvasThumb.height,
																		orientation: 0,
																		scale: 1,
																	})

																	compressThumb.then((thumbValue) => {
																		const thumbUrl = imageConversion.filetoDataURL(thumbValue)
																		thumbUrl.then((decodeThumb) => {
																			let name = 'id' + (index + 1) + '_' + pfx[0] + '.' + pfx[1]

																			const imgUpload = {
																				name: name,
																				large: decodeLarge,
																				medium: decodeMedium,
																				small: decodeSmall,
																				thumb: decodeThumb,
																			}

																			const formData = {
																				cmd: 'uploadImage',
																				blockname: activeBlock,
																				images: imgUpload,
																			}

																			const response = admin(formData)

																			response.then((v) => {
																				filesCounter++

																				if (filesCounter === images.length) {
																					const configFile = update_config_file(
																						activeBlock,
																						singleImageBlock,
																						hasLogo,
																						isLinked,
																						blockTitle,
																						blockIntro,
																						files
																					)

																					configFile.then((cv) => {
																						const totalStorage = get_file_size()
																						totalStorage.then((sv) => {
																							storeRemainingStorage.set(sv)
																							storeUploader.set(false)
																						})
																					})
																				}
																			})
																		})
																	})
																})
															})
														}) // close small to url
													}) //close small compress
												}) //close medium canvas to file
											}) //close medium compress
										}) //close medium file to url
									}) // close large canvas to file
								}) //close large compress
							}) //close large file to url
						}
					}
				}
			}
		})

		if (filesCounter === images.length) {
			const configFile = update_config_file(
				activeBlock,
				singleImageBlock,
				hasLogo,
				isLinked,
				blockTitle,
				blockIntro,
				files
			)
			configFile.then((value) => {
				const totalStorage = get_file_size()
				totalStorage.then((value) => {
					storeRemainingStorage.set(value)
					storeUploader.set(false)
				})
			})
		}
	}

	onDestroy(() => {
		stoActBlock
		storeUpdate.set(false)
		storeActiveBlock.set(null)
		storeIsLinked.set(false)
		storeSingleImageBlock.set(false)
		if ($storeUpdateSingle) document.location = '#/builder'
	})
</script>

<main>
	<Shader opacity=".8">
		<div slot="content">
			<Timer fontLarge={fsN} fontSmall={fsS} titleColor={colorMain} />
			<div use:styles={{ fsXS, colorMain }} class="upload_info">
				<div style="margin-bottom: 20px;text-align:center;">
					Depending on your file-sizes and your internet-connection<br />the upload process might take some time<br
					/><br />PLEASE BE PATIENT!
				</div>
				<Spinner color="hsl(0,0%,60%)" />

				<div style="margin-top: 20px;margin-bottom:20px">
					{filesCounter} of {files.length} files uploaded
				</div>
			</div>
		</div>
	</Shader>
</main>

<style>
	.upload_info {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		color: var(--colorMain);
		font-size: var(--fontXS);
	}
</style>
